import React from 'react'
import clsx from 'clsx'
import {
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
  useTheme
} from '@mui/material'
import { ArrangeVertical, Sort } from 'iconsax-react'

import Menu from '../../../atoms/Menu'

import { useSocket } from '@SonarCX/providers/SocketProvider'
import useStyles from './styles'

const channelOptions = ['All', 'Live Chat', 'Email', 'SMS']

const sortOptions = ['Newest', 'Oldest', 'Name (A-Z)', 'Name (Z-A)']

type PeerChatFiltersType = {
  updateSort: React.Dispatch<React.SetStateAction<string>>
  children?: React.ReactNode
}

const PeerChatFilters: React.FC<PeerChatFiltersType> = ({
  updateSort,
  children
}) => {
  const theme = useTheme()

  const {
    peerChat: { selectedFilter, filters },
    api: { handleFilterChange }
  } = useSocket()
  const [channel, setChannel] = React.useState([channelOptions[0]])
  const [sort, setSort] = React.useState(sortOptions[0])

  const classes = useStyles()

  React.useEffect(() => {
    if (channel?.length > 1 && channel.includes(channelOptions[0])) {
      setChannel(cs => cs.filter(c => c !== channelOptions[0]))
    }
  }, [channel])

  return (
    <div className={classes.root}>
      <Menu
        className={classes.chatFilters}
        menuClassName={classes.menu}
        disablePadding
        closeOnClick
        title='Filter by Status'
        optionsComponent={
          <FormControl className={classes.control}>
            <RadioGroup
              name='status'
              value={selectedFilter}
              onChange={e => handleFilterChange(e.target.value, true)}
            >
              {filters.map((val, i) => (
                <FormControlLabel
                  key={i}
                  value={val}
                  label={val}
                  onClick={() => handleFilterChange(val, true)}
                  control={
                    <Radio
                      color='primary'
                      size='small'
                      className={classes.radio}
                    />
                  }
                  className={clsx(
                    classes.controlLabel,
                    val === selectedFilter && classes.controlLabelBold
                  )}
                />
              ))}
            </RadioGroup>
          </FormControl>
        }
      >
        <Sort size={theme.size.sm} className='icon' />

        <div className='text'>{selectedFilter.toUpperCase()}</div>
      </Menu>

      <Menu
        className={classes.chatFiltersLast}
        menuClassName={classes.menu}
        disablePadding
        closeOnClick
        title='Sort results by:'
        optionsComponent={
          <FormControl className={classes.control}>
            <RadioGroup
              name='sort'
              value={sort}
              onChange={e => {
                setSort(e.target.value)
                updateSort(e.target.value)
              }}
            >
              {sortOptions.map((val, i) => (
                <FormControlLabel
                  key={i}
                  value={val}
                  label={val}
                  onClick={() => {
                    setSort(val)
                    updateSort(val)
                  }}
                  control={
                    <Radio
                      color='primary'
                      size='small'
                      className={classes.radio}
                    />
                  }
                  className={clsx(
                    classes.controlLabel,
                    val === sort && classes.controlLabelBold
                  )}
                />
              ))}
            </RadioGroup>
          </FormControl>
        }
      >
        <ArrangeVertical size={theme.size.sm} className='icon' />

        <div className='text'>{sort.toUpperCase()}</div>
      </Menu>

      {children}
    </div>
  )
}

export default React.memo(PeerChatFilters)
